import {
  EnvironmentProviders,
  importProvidersFrom,
  Provider,
} from '@angular/core';
import { ApiModule, Configuration } from '@libs/shared/api';
import { environment } from '@sprint-backoffice/environments/environment';

export const provideApi = (): Array<Provider | EnvironmentProviders> => {
  return [
    importProvidersFrom(
      ApiModule.forRoot(
        () =>
          new Configuration({
            basePath: environment.apiBaseUrl.web,
            withCredentials: true,
          })
      )
    ),
  ];
};
